import { IRace } from "@fdr/types/ts/Derby";
import {
  SetHomepageConfigAction,
  SetHomepageEventAction,
  SetHomepageOrderAction,
  SetHomepageEventStatusAction,
  SetHomepageDerbyRaceAction,
  SetHasRequestAction
} from "./types";
import {
  HomepageConfig,
  HomepageConfigEventInfo,
  HomepageConfigOrder,
  HomepageConfigType
} from "../utils/types";

export const setHomepageConfig = (
  value: HomepageConfig
): SetHomepageConfigAction => ({
  type: "SET_HOMEPAGE_CONFIG",
  payload: value
});

export const setHomepageOrder = (
  value: HomepageConfigOrder
): SetHomepageOrderAction => ({
  type: "SET_HOMEPAGE_ORDER_ACTION",
  payload: value
});

export const setHomepageEvent = (
  value: HomepageConfigEventInfo
): SetHomepageEventAction => ({
  type: "SET_HOMEPAGE_EVENT",
  payload: value
});

export const setHomepageEventStatus = (
  value: HomepageConfigType
): SetHomepageEventStatusAction => ({
  type: "SET_HOMEPAGE_EVENT_STATUS",
  payload: value
});

export const setHomepageDerbyRace = (
  value: IRace
): SetHomepageDerbyRaceAction => ({
  type: "SET_HOMEPAGE_DERBY_RACE",
  payload: value
});

export const setHasRequest = (): SetHasRequestAction => ({
  type: "SET_HAS_REQUEST"
});
